module.exports = __webpack_public_path__ + "media/images/svg/twitter-f2350f41fae38bb2b025e3479799521d.svg";